export const CLIENT_URL = "https://travelbee.onrender.com";
